import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type IBillPaymentProps } from "entity/bill/BillPayment/BillPayment";

const BillPayment = lazyLoadWithRetry(() => import("entity/bill/BillPayment/BillPayment"));

export const RouteBillPayment = (
    props: Omit<IBillPaymentProps, "id" | "jobId" | "history" | "location" | "match">,
) => (
    <RouteRelative
        path={routes.billPayment.details}
        render={(routeProps) => {
            return (
                <BTSuspense>
                    <BillPayment
                        {...props}
                        {...routeProps}
                        id={parseInt(routeProps.match.params.id)}
                    />
                </BTSuspense>
            );
        }}
    />
);
